<!-- 
Panel for showing details of a PRISMS user.
-->
<template>
  <div>
    <our-loading-indicator v-if="state.loading"/>
    <div v-else>
      <our-data-container>
        <our-data-field label="First name">{{ user.firstName }}</our-data-field>
        <our-data-field label="Family name">{{ user.familyName }}</our-data-field>
        <our-data-field label="Email">{{ user.emailAddress }}</our-data-field>
      </our-data-container>
      <v-divider />
      <our-data-container>
        <our-data-field label="Status">{{ lookups.userStatusDescriptions[user.status] }}</our-data-field>
        <our-data-field label="Last logon">{{ user.lastLogonDate | longDateTime }}</our-data-field>
        <our-data-field label="Failed logon attempts">{{ user.failedAttempts }}</our-data-field>
        <our-data-field label="Password expiry date">{{ user.passwordExpiryDate | longDate }}</our-data-field>
      </our-data-container>
      <v-divider />
      <our-data-container>
        <our-data-field label="User type">{{ user.userTypeRefCode }}</our-data-field>
        <our-data-field label="Roles">
          <our-lookups-list :values="user.roles" :lookups="lookups.roleCodes"/>
        </our-data-field>
      </our-data-container>
      <v-divider />
      <our-data-container>
          <our-data-field label="Multi-Factor Authentication">{{ user.mfaStatus }}</our-data-field>
      </our-data-container>
    </div>
  </div>
</template>

<script>
import filterMixins from "@/mixins/filter.mixins";
import lookupMixins from "@/mixins/lookup.mixins";
import * as action from "@/store/prisms-users/action-types";

export default {
  mixins: [filterMixins, lookupMixins],
  props: {
    userId: {
      required: true,
      type: Number
    }
  },
  computed: {
    user() {
      return this.state.data;
    },
    state() {
      return this.$store.state.prismsUsers.view;
    }
  },
  watch: {
    userId() {
      this.refresh();
    }
  },
  mounted() {
    this.refresh();
  },
  methods: {
    refresh() {
      this.$store.dispatch(action.VIEW_REFRESH, this.userId);
    }
  }
};
</script>
